module.exports = __webpack_public_path__ + "static/logo-7ed66d22e32a5502fc90f1c0587d0c0a.gif";